/**
 * Global error context for crash reporting (route, feature, last action).
 * Set from App on location change so ErrorBoundary and global handlers can log context.
 */

export interface ErrorContext {
  route: string;
  feature: string;
  lastAction?: string;
}

let current: ErrorContext = { route: '', feature: 'app' };

export function setErrorContext(ctx: Partial<ErrorContext>): void {
  current = { ...current, ...ctx };
}

export function getErrorContext(): ErrorContext {
  return { ...current };
}
